// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__FHGKl"};